// Central site & product configuration — single source of truth for external links.
export const SITE = {
  platform: "VS PartnerHub",
  company: "Vijay Software Solutions Pvt Ltd",
  brand: "VS-Solutions",
  tagline: "Connect. Source. Collaborate. Grow.",
  website: "https://www.vs-solutions.in",
  contactEmail: "contact@vs-solutions.in",
  // STRICT ASSET SEPARATION — these two must never share a source.
  // platformLogo: official VS mark, used ONLY as the app/platform icon (favicon, header, auth, dashboard shell).
  platformLogo: "/vs-logo.png",
  // founderProfileImage: Vijay Bhargav photograph, used ONLY in the homepage Founder section.
  founderProfileImage: "/founder.png",
};

// Public homepage capability metrics — platform architecture facts, NOT business volume claims.
export const GLANCE_METRICS = [
  { value: "3", label: "Business Workspaces", desc: "Client, Vendor and Staffing Partner — each purpose-built." },
  { value: "15+", label: "Core Business Modules", desc: "Requirements, RFQs, candidates, contracts, finance and more." },
  { value: "360°", label: "Record Visibility", desc: "Complete lifecycle of every business record, connected." },
  { value: "24/7", label: "Digital Platform Access", desc: "Your authorized workspace, whenever operations require it." },
  { value: "End-to-End", label: "Business Workflows", desc: "Requirement to payment. Requirement to deployment." },
  { value: "Real-Time", label: "Operational Visibility", desc: "Monitor approvals, interviews, documents and activity." },
  { value: "Role-Based", label: "Access Control", desc: "Permissions enforced by role, organization and record." },
  { value: "AI-Assisted", label: "Business Intelligence", desc: "VS AI assists — humans always decide." },
];

export const MANAJODI_PRODUCT_URL = "https://manajodi.org";
export const BITEGO_PRODUCT_URL = "https://bitego.org";
export const VSSAFEHER_PRODUCT_URL = ""; // Not launched yet — stays "Coming Soon" until configured.

export const PRODUCTS = [
  {
    name: "VS PartnerHub",
    category: "Enterprise Platform",
    desc: "Enterprise partnership and business operations platform.",
    letter: "V",
    gradient: "from-blue-600 to-indigo-700",
    url: "#platform",
    external: false,
    testid: "product-partnerhub",
  },
  {
    name: "BiteGo",
    category: "Food Delivery & Restaurant Tech",
    desc: "Food delivery and restaurant technology ecosystem.",
    letter: "B",
    gradient: "from-orange-500 to-red-600",
    url: BITEGO_PRODUCT_URL,
    external: true,
    testid: "product-bitego",
  },
  {
    name: "ManaJodi",
    category: "Matrimonial & Relationships",
    desc: "Profiles, preferences and compatibility matching.",
    letter: "M",
    gradient: "from-rose-500 to-pink-600",
    url: MANAJODI_PRODUCT_URL,
    external: true,
    testid: "product-manajodi",
  },
  {
    name: "VSSafeHer",
    category: "Women Safety Technology",
    desc: "Personal safety, alerts and connected assistance.",
    letter: "S",
    gradient: "from-violet-600 to-purple-700",
    url: VSSAFEHER_PRODUCT_URL || null,
    external: true,
    comingSoon: !VSSAFEHER_PRODUCT_URL,
    testid: "product-vssafeher",
  },
];
